import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import RastreioPublico from './pages/RastreioPublico';

const Layout = lazy(() => import('./components/Layout'));
const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Configuracoes = lazy(() => import('./pages/Configuracoes'));

function PageLoader() {
  return (
    <div className="loading">
      <div className="spinner" />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/rastreio" element={<RastreioPublico />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Login />} />

            <Route path="/admin" element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="configuracoes" element={<Configuracoes />} />
            </Route>

            <Route path="/" element={<Navigate to="/rastreio" replace />} />
            <Route path="/:numero" element={<RastreioPublico />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
